import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router-dom';
import '../../assets/stylesheets/Messages/MessagesPage.scss'
import { faChevronLeft, faRedo } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {useDispatch, useSelector} from 'react-redux';
import { getMessageList } from "../../store/selectors";
import { requestAllMessages, requestDeleteMessages } from "../../store/actionCreators/messages";
import { MsgHeader } from "./components";

const Messages = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { id: clubId } = useParams();
    const arrMessages = useSelector(getMessageList);
    const [isLoading, setLoading] = useState('');
    const [readMessageIds, setReadMessageIds] = useState([]);
    const reloadMessages = () => {
        dispatch(requestAllMessages(clubId));
    };

    const deleteMessages = () => {
        dispatch(requestDeleteMessages(readMessageIds));
    };

    useEffect(() => {
        dispatch(requestAllMessages(clubId));
    }, []);

    useEffect(() => {
        arrMessages.isLoading ? setLoading('loadingMessages') : setLoading('');
        if(!arrMessages.isLoading) setReadMessageIds(arrMessages.reduce((acc, msg) => {
            if(msg.status === "read" && !!msg.templateId && !!msg.data) 
                acc.push(msg._id)
            return acc;
            }, []));
    }, [arrMessages]);

    return (
        <div>
            <div className={`messages`}>
                <div className={`header`}>
                    <Link to={!!clubId ? `/club/${clubId}` : '/'} className={`arrow`}>
                        <FontAwesomeIcon icon={faChevronLeft} color="white" className="fa chevron-left"></FontAwesomeIcon>
                    </Link>
                    <span>{`${!!clubId ? t('club.text') : ''} ${t('footer.items.messages')}`}</span>
                    <button className={`reload ${isLoading}`} onClick={reloadMessages}>
                        <FontAwesomeIcon icon={faRedo} color="white" className="fa-redo"></FontAwesomeIcon>
                    </button>
                </div>
                <div className={`messagesList scrollable`}>
                    {arrMessages.length > 0 ?
                        (<div>
                            { arrMessages.map(msg => <MsgHeader clubId={clubId} key={msg._id} msg={msg} />)}
                        </div>)
                        : <div className={`empty`}>
                            <div className={`box`}></div>
                            <p>{t('messages.noMessages')}</p>
                        </div>
                    }
                </div>
                {arrMessages.length > 0 &&
                    <div onClick={deleteMessages} className={`messageText`}>{t('messages.deleteMessages')}</div>
                }
            </div>
        </div>
    )
};

export default Messages;
